export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const FETCH_LOADING_START = 'FETCH_LOADING_START';
export const FETCH_FAILED = 'FETCH_FAILED';
export const EMPTY_LOCAL_STORAGE = 'EMPTY_LOCAL_STORAGE';
export const RESET_DETAILS = 'RESET_DETAILS';
